var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCodeUploadTwoTone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 36,
    viewBox: "0 0 50 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.06897 18.1356C0.61545 22.9012 0.0347437 24.9131 0.00840835 25.275C-0.0946667 26.6902 0.759395 28.1512 2.04975 28.7672C2.47619 28.9707 5.61791 29.8249 15.346 32.382C22.3518 34.2236 28.2758 35.7795 28.5105 35.8397C29.008 35.9672 29.8868 35.9795 30.3891 35.8658C31.3102 35.6573 32.3166 34.916 32.7564 34.122C32.8714 33.9143 33.3183 32.6424 33.7494 31.2955C34.1805 29.9486 34.5526 28.7861 34.5764 28.7122C34.6174 28.5846 33.989 28.5778 22.1304 28.5773C9.97059 28.5768 9.62432 28.5728 8.99845 28.4253C6.7072 27.8856 5.01212 26.2383 4.34311 23.9011C4.18111 23.3352 4.17502 23.1445 4.13454 17.4091L4.09289 11.5L2.06897 18.1356Z",
    fill: "var(--secondary-1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94121 2.25948C7.48799 1.15755 8.61018 0.316455 9.86044 0.0715899C10.0324 0.0378816 16.0106 0.00701435 23.1453 0.00302157C35.6902 -0.00400391 36.564 -0.0251146 37.2723 0.306944C37.3691 0.352322 37.4627 0.404297 37.5827 0.463804C38.595 0.965897 39.5066 2.15375 39.7439 3.27979C39.8034 3.56236 39.8292 6.56624 39.8284 13.1082C39.8273 22.0869 39.8447 22.9575 39.5102 23.6606C39.4563 23.7739 39.3933 23.8829 39.3196 24.0207C38.8514 24.8961 38.0244 25.6056 37.0523 25.966L36.5865 26.1386L23.3798 26.1589C14.3109 26.1729 10.0477 26.1538 9.77292 26.0979C8.37394 25.8136 7.11375 24.6764 6.67324 23.3008L6.50015 22.7601V13.1236C6.50015 4.04983 6.4843 3.24454 6.78261 2.58036C6.82786 2.47961 6.88034 2.38211 6.94121 2.25948ZM25.8305 5.04896L23.0322 4.48703L20.4305 21.111L23.2288 21.673L25.8305 5.04896ZM36.3659 13.0184L30.064 6.69083L28.0481 8.71493L32.3341 13.0184L28.0481 17.3219L30.064 19.346L36.3659 13.0184ZM18.2725 8.71493L16.2566 6.69083L9.95459 13.0184L16.2566 19.346L18.2725 17.3219L13.9864 13.0184L18.2725 8.71493Z",
    fill: "var(--secondary-3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0017 35.1111C45.9291 35.1111 49.1128 31.9274 49.1128 28C49.1128 24.0727 45.9291 20.8889 42.0017 20.8889C38.0744 20.8889 34.8906 24.0727 34.8906 28C34.8906 31.9274 38.0744 35.1111 42.0017 35.1111ZM41.1684 32.4445V28.8333H37.5573V27.1667H41.1684V23.5556H42.8351V27.1667H46.4462V28.8333H42.8351V32.4445H41.1684Z",
    fill: "var(--secondary-7)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeUploadTwoTone);
export default __webpack_public_path__ + "static/media/codeUploadTwoTone.db22d190dcc8a938f04cc3c8fcad662c.svg";
export { ForwardRef as ReactComponent };